export default __webpack_public_path__ + "static/media/folder.090295ff.svg";